"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeroAnimation = void 0;
const run_when_visible_1 = require("../utils/run-when-visible");
class HeroAnimation {
    constructor(elements) {
        elements.forEach((element) => (0, run_when_visible_1.RunWhenVisible)(element, HeroAnimation.init));
    }
    static init() {
        const heroOverflowElem = document.querySelector('.hero-overflow');
        const contentElem = document.querySelector('section.hero .text');
        const navbarElem = document.querySelector('.navbar-default');
        const bodyElem = document.body;
        window.addEventListener('wheel', (event) => {
            const scrollDir = Math.sign(event.deltaY);
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (bodyElem.classList.contains('no-scroll') &&
                scrollDir === 1 &&
                !heroOverflowElem.classList.contains('playing')) {
                heroOverflowElem === null || heroOverflowElem === void 0 ? void 0 : heroOverflowElem.classList.add('anim');
                contentElem === null || contentElem === void 0 ? void 0 : contentElem.classList.add('anim');
            }
            if (scrollTop === 0 && scrollDir === -1 && !heroOverflowElem.classList.contains('playing')) {
                bodyElem.classList.add('no-scroll');
                heroOverflowElem === null || heroOverflowElem === void 0 ? void 0 : heroOverflowElem.classList.remove('anim');
                contentElem === null || contentElem === void 0 ? void 0 : contentElem.classList.remove('anim');
                navbarElem === null || navbarElem === void 0 ? void 0 : navbarElem.classList.add('transparent');
            }
        });
        heroOverflowElem.addEventListener('transitionstart', function (e) {
            if (e.propertyName === 'transform') {
                heroOverflowElem.classList.add('playing');
            }
        });
        heroOverflowElem.addEventListener('transitionend', function (e) {
            var _a;
            if (e.propertyName === 'transform') {
                heroOverflowElem.classList.remove('playing');
                if (heroOverflowElem.classList.contains('anim')) {
                    bodyElem.classList.remove('no-scroll');
                    (_a = document.querySelector('.navbar-default')) === null || _a === void 0 ? void 0 : _a.classList.remove('transparent');
                }
            }
        });
    }
}
exports.HeroAnimation = HeroAnimation;
